/** @jsxImportSource @emotion/react */
import { Theme, css } from '@emotion/react';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { useEffect, useState } from 'react';

import createIcon from '@public/icons/bottomTab/ic_bottom_tab_create.png';
import createActiveIcon from '@public/icons/bottomTab/ic_bottom_tab_create_active.png';
// 이미지 임포트
import homeIcon from '@public/icons/bottomTab/ic_bottom_tab_home.png';
import homeActiveIcon from '@public/icons/bottomTab/ic_bottom_tab_home_active.png';
import libraryIcon from '@public/icons/bottomTab/ic_bottom_tab_library.png';
import libraryActiveIcon from '@public/icons/bottomTab/ic_bottom_tab_library_active.png';
import studioIcon from '@public/icons/bottomTab/ic_bottom_tab_studio.png';
import studioActiveIcon from '@public/icons/bottomTab/ic_bottom_tab_studio_active.png';

import { useGlobalContext } from '@contexts/global';

import { Platform } from '../../constants';
import { responsiveMaxWidth } from '../../styles/css';

// 탭 버튼 정보
const buttons = [
  { path: '/play', icon: homeIcon, activeIcon: homeActiveIcon, alt: '홈' },
  {
    path: '/play/characters/create',
    icon: createIcon,
    activeIcon: createActiveIcon,
    alt: '만들기',
  },
  {
    path: '/library',
    icon: libraryIcon,
    activeIcon: libraryActiveIcon,
    alt: '보관함',
  },
  {
    path: '/studio',
    icon: studioIcon,
    activeIcon: studioActiveIcon,
    alt: '마이페이지',
  },
];

// Emotion 스타일
const bottomTabCSS = (theme: Theme) => css`
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  ${responsiveMaxWidth};
  margin: 0 auto;
  box-shadow: 0 0 4px 0 rgba(95, 95, 95, 0.1);
  border-top: 1px solid ${theme.var.gray200};
  padding-bottom: env(safe-area-inset-bottom);
  background-color: ${theme.var.white};
  z-index: 9000;
`;

const buttonCSS = (isActive: boolean) => (theme: Theme) =>
  css`
    flex-grow: 1;
    text-align: center;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 8px 0;
    cursor: pointer;

    img {
      height: 28px;
    }

    p {
      font-size: 0.625rem;
      margin-top: 3px;
      color: ${isActive ? theme.colors.main500 : theme.var.gray300};
    }
  `;

const BottomTab = () => {
  const router = useRouter();
  const { platform } = useGlobalContext();
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  useEffect(() => {
    const currentIndex = buttons.findIndex(
      (button) => button.path === router.pathname
    );
    setSelectedButtonIndex(currentIndex !== -1 ? currentIndex : 0);
  }, [router.pathname]);

  // 웹이 아니라면 숨김
  if (platform !== Platform.web) {
    return null;
  }

  return (
    <>
      <footer css={bottomTabCSS}>
        {buttons.map((button, index) => (
          <Link key={button.alt} href={button.path} prefetch={false}>
            <a css={buttonCSS(selectedButtonIndex === index)}>
              <Image
                width={24}
                height={24}
                src={
                  selectedButtonIndex === index
                    ? button.activeIcon
                    : button.icon
                }
                loader={({ src }) => src}
                alt={button.alt}
              />
              <p>{button.alt}</p>
            </a>
          </Link>
        ))}
      </footer>
    </>
  );
};

export default BottomTab;
